export const getDataWithOrganisationId = (
data,
getOrganisationId) => (
{ ...data, organisationId: getOrganisationId(data) });

export const getDataWithoutOrganisationId = ({
  organisationId,
  ...props
}) => ({ ...props });